import { IKImage } from "imagekitio-next";
import React from "react";

type SmallProductThumbnailProps = {
  imageName: string;
  alt: string;
};

const urlEndpoint = process.env.NEXT_PUBLIC_BASE_IMAGE_KIT_URL;
const SmallProductThumbnailUrlWidth = 60;
const SmallProductThumbnailUrlHeight = 60;

const SmallProductThumbnail = (props: SmallProductThumbnailProps) => {
  return (
    <IKImage
      urlEndpoint={urlEndpoint}
      path={props?.imageName || "default_image.jpg"}
      transformation={[{ crop: "maintain_ratio" }]}
      width={SmallProductThumbnailUrlWidth}
      height={SmallProductThumbnailUrlHeight}
      alt={props?.alt}
      lqip={{ active: true, quality: 20 }}
      loading="lazy"
      className="bg-contain border-2 image-border"
      style={{
        maxWidth: "100%",
        height: "auto",
      }}
    />
  );
};

export default SmallProductThumbnail;
